import { create } from "zustand";

const useUserStore = create((set) => ({
  userName: null,
  userLogin: (email, password) => ({}),
}));

export default useUserStore;
